import React, { CSSProperties } from 'react';
import styled, { CSSProp } from 'styled-components';

interface IStackProps {
  justify?: CSSProperties['justifyContent'];
  align?: CSSProperties['alignItems'];
  margin?: CSSProperties['margin'];
  padding?: CSSProperties['padding'];
  fluid?: boolean;
  gap?: string;
  fullHeight?: boolean;
  maxHeight?: CSSProperties['maxHeight'];
  overflowAuto?: boolean;
}

const Stack = styled.div<IStackProps>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ justify }) => justify || 'start'};
  align-items: ${({ align }) => align || 'stretch'};
  gap: ${({ gap }) => gap || '5px'};
  width: ${({ fluid }) => (fluid ? '100%' : 'auto')};
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
  margin: ${({ margin }) => margin || 0};
  max-height: ${({ maxHeight }) => maxHeight || 'auto'};
  padding: ${({ padding }) => padding || 0};
  overflow: ${({ overflowAuto = false }) => (overflowAuto ? 'auto' : 'unset')};
`;

export default Stack;
